<section id="ngx-datatable-filter">
    <div class="row">
      <div class="col-12"></div>
      <div class="col-12">
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <fieldset class="form-group">
                <div class="row align-items-end mt-0 pagination-body">
                  <div class="d-flex  col-12 col-sm-12 col-md-6 col-lg-6 mt-1 mb-1 date-filter">
                    <div class=" mr-2">
                      <label>From Date</label>
                      <input type="date" [(ngModel)]="fromDate" class="form-control" (change)="getStartDate($event)">
                    </div>
                    <div class=" mr-2">
                      <label>To Date</label>
                      <input [(ngModel)]="toDate" type="date" class="form-control" (change)="getEndDate($event)">
                    </div>
                  </div>
                  <div class="col-12 col-sm-12 col-md-6 col-lg-6 mt-2 mb-1">
                    <div class="row-flex">
                      <div class="col-flex-2 mb-1 position-relative">
                        <input id="ngx-filter-ref"
                          class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
                          type="text" placeholder="Search" #name (keydown.enter)="filterTask(searchVal)"
                          [(ngModel)]="searchVal" />
                        <button class="btn search-btn glow position-absolute" (click)="filterTask(searchVal)">
                          <i class="ft-search text-white cursor-pointer"></i>
                        </button>
                      </div>
                      <div class="col-flex-2 mb-1">
                        <button class="btn btn-primary btn-block users-list-clear glow mb-0" (click)="resetFilter()">Reset
                          <i class="ft-filter text-white cursor-pointer"></i>
                        </button>
                      </div>
                      <div class="col-flex-2 mb-1"
                        *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                        <button type="reset" class="btn btn-primary btn-block users-list-clear glow mb-0"
                          (click)="openModalLeave(myModal,'','')" placement="top" ngbTooltip="Add New">
                          +
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 d-flex justify-content-between my-2">
                    <!-- <div class="row"> -->
                      <div>
                        <button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Leave Guideline</button>
                      </div>
                      <div>
                        <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="40"
                        [footerHeight]="40" rowHeight="auto" [limit]="limitRef" [rows]="rows" [externalPaging]="true"
                        [count]="page.totalPages" [offset]="page.pageNumber" (page)="pageChangeData($event)"></ngx-datatable>
                      </div>
                    <!-- </div> -->
                  </div>
                </div>
              </fieldset>
              <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
                [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows" [scrollbarH]="true"
                [columns]="columns" [count]="page.totalPages" [externalPaging]="true" [offset]="page.pageNumber" (change)="pageChangeData($event)">
                <ngx-datatable-column name="Name" prop="to" [width]="220">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <div class="d-flex align-items-center">
                      <div class="avatar mr-1 ml-0 bg-primary">
                        <div class="avatar-content">
                          {{row?.user[0]?.name | shortName }}
                        </div>
                      </div>
                      <div class="cell-line-height cursor-pointer">
                        <p *ngFor="let item of row?.user" class="font-medium-1 line-height-1 mb-0">
                          {{item.name }}
                        </p>
                        <div>
                          <p class="user-email mb-0">{{row?.user[0]?.email}}</p>
                          <p class="mb-1">{{row?.user[0]?.phone}}</p>
                          <p class="badge badge-pill bg-light-primary">{{row?.user[0]?.employees?.employeetype[0]?.displayname}}</p>
                        </div>
                      </div>
                      
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Date" prop="date" [width]="30">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <div class="d-flex align-items-center">
                      <div class="cell-line-height">
                        <p class="font-medium-1 line-height-1 mb-0">
                          {{ row?.created_at |customDate }}
                        </p>
                      </div>
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                
              <ngx-datatable-column name="Title" prop="title" [width]="60">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <div class="d-flex align-items-center">
                    <div class="cell-line-height">
                      <p class="font-medium-1 line-height-1 mb-0">
                        {{ row?.title }}
                      </p>
                    </div>
                  </div>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="From-To" prop="from" [width]="80">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    {{row?.from }} - {{row?.to_date}}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Transferred " prop="transferred_to" [width]="50">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                   {{row?.transferred_to}}
                </ng-template>
              </ngx-datatable-column>
              
                <ngx-datatable-column name="Status" prop="status" [width]="20">
                  
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <p [matMenuTriggerFor]="status">
                      <span *ngIf="row?.status[0]?.displayname == 'Open'"
                                  [ngClass]="{'bg-light-success badge badge-pill':row?.status[0]?.displayname == 'Open'}">
                                  {{row?.status[0]?.displayname}}
                                </span>
                                <span *ngIf="row?.status[0]?.displayname == 'In-Progress'"
                                  [ngClass]="{'bg-light-warning badge badge-pill':row?.status[0]?.displayname == 'In-Progress'}">
                                  {{row?.status[0]?.displayname}}
                                </span>
                                <span *ngIf="row?.status[0]?.displayname == 'Closed'"
                                  [ngClass]="{'bg-light-danger badge badge-pill':row?.status[0]?.displayname == 'Closed'}">
                                  {{row?.status[0]?.displayname}}
                                </span>
                    </p>
                    <mat-menu #status="matMenu">
                      <div *ngFor="let status of status_list">
                        <button mat-menu-item *ngIf="status?._id !== row?.status[0]?.displayname"
                          (click)="updateStatus(row._id,status._id)">
                          <span>
                          <span [ngClass]="{'bg-light-success badge badge-pill':status.displayname == 'Open'}"
                            placement="top" *ngIf="status.displayname == 'Open'">{{status.displayname}}</span>
                          <span [ngClass]="{'bg-light-warning badge badge-pill':status.displayname == 'In-Progress'}"
                            placement="top" *ngIf="status.displayname == 'In-Progress'">{{status.displayname}}</span>
                          <span [ngClass]="{'bg-light-danger badge badge-pill':status.displayname == 'Closed'}"
                            placement="top"
                            *ngIf="status.displayname == 'Closed'">{{status.displayname}}</span>
                          </span>
                        </button>
                        </div>
                    </mat-menu>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Request  " prop="body" [width]="10">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                     <p placement="left" ngbTooltip="click to view request info" (click)="openModalView(myModal22,row?.body,'body')">Link</p>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Reply " prop="admin_notes" [width]="10">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <p placement="left" ngbTooltip="click to view reply info" (click)="openModalView(myModal22,row,'admin_notes')">Link</p>
                  </ng-template>
                </ngx-datatable-column>
  
                <ngx-datatable-column name="Actions" [width]="10"
                  *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <i mat-button [matMenuTriggerFor]="menu1"
                      class="ft-more-vertical text-primary cursor-pointer mr-2"></i>
  
                    <mat-menu #menu1="matMenu">
                      <button mat-menu-item (click)="openModalLeave(myModal,row._id,row)">Edit</button>                     
                      <button mat-menu-item (click)="confirmDelete(row._id)">Delete</button>
                    </mat-menu>
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
              <!-- ngx-datatable-filter -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  <!--------------  Popup ------------------------------------------->
<div>
	<ng-template #myModal let-modal>
		<div class="modal-header">
			<h4 class="modal-title" *ngIf="!task_id">Add Leave</h4>
			<h4 class="modal-title"  *ngIf="task_id">Update Leave</h4>
			<button type="button" class="close" (click)="modal.dismiss()">
				<span>&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<form>
        <div class="form-group">
          <label>User</label>
          <ng-select
            [items]="empFull_list"
            bindLabel="userName"
            bindValue="userId"
            [closeOnSelect]="false"
            placeholder="Select user"
            [(ngModel)]="selected_emp"
            [ngModelOptions]="{ standalone: true }"
            (change)="getEmpIdd($event)"
          >
          </ng-select>
          </div>
				<div class="form-group">
          <label>From Date</label>
          <input type="date" class="form-control" [formControl]="from_date"  [max]="max_date" [ngModel]="task_leave_model.from_date | date: 'yyyy-MM-dd'" (ngModelChange)="updateBody()" >
        </div>
        <div class="form-group">
          <label>To Date</label>
          <input type="date" class="form-control" [formControl]="to_date"  [max]="max_date" [ngModel]="task_leave_model.to_date | date: 'yyyy-MM-dd'" (ngModelChange)="updateBody()">
        </div>
        <div class="form-group">
          <label>Title</label>
					<input type="text" class="form-control" [formControl]="title" [(ngModel)]="task_leave_model.title"  [ngModelOptions]="{standalone: true}" (ngModelChange)="updateBody()">
        </div>
        <div class="form-group">
          <label>Knowledge Transafer To</label>
          <ng-select
				  [items]="empFull_list"
				  bindLabel="userName"
				  bindValue="userId"
				  placeholder="Select user"
				  [(ngModel)]="selected_empFull"
				  [ngModelOptions]="{ standalone: true }"
				  (change)="getEmpId($event)"
				>
				</ng-select>
        </div>
        <div class="form-group">
          <label>Body</label>
					<textarea name="body" id="body" cols="30" rows="17" class="form-control" [(ngModel)]="task_leave_model.body"  [ngModelOptions]="{standalone: true}" readonly></textarea>
        </div>
			</form>
			
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
			<button type="button" class="btn btn-primary" (click)="submit()">Submit</button>

		  </div>
	</ng-template>
</div>
<!-------------- Request And Reply  Popup ------------------------------------------->
<div>
  <ng-template #myModal22 let-modal>
    <div class="modal-header">
      <h4 class="modal-title" *ngIf="request_info">Leave Request Info</h4>
      <h4 class="modal-title" *ngIf="isReply">Leave Reply</h4>

      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="d-flex" *ngIf="request_info">
        <p class="request-box">Request Info :</p>
        <p [innerHTML]="request_info"></p>
      </div>
      <div *ngIf="isReply">
        <label>Reply</label>
        <textarea class="form-control" name="reply_info" [(ngModel)]="reply_info" id="reply_info" cols="30" rows="5"></textarea>
      </div>
    </div>
    <div class="modal-footer">
      <button *ngIf="isReply" type="button" class="btn btn-primary" (click)="updateNotes()">Submit</button>
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
      </div>
  </ng-template>
</div>
